export default {
  en: {
    messages: {
      notificationSettings: "Notification Settings",
      loadingAddressBook: "Loading address book...",
      failedToLoadAddressBook: "Failed to load address book",
      recipients: "Recipients",
      noAddressBookEntries: "No address book entries found",
      manageAddressBook: "Manage Address Book",
      cancel: "Cancel",
      save: "Save",
      resultFilters: "Result Filters",
      filterInstructions: "Add filters to customize which results are sent to this recipient.",
      filterPlaceholder: "e.g., location:New York",
      addFilter: "Add Filter",
      filterExamples: "Filter examples:",
      apply: "Apply",
      noFilters: "No filters",
      oneFilter: "1 filter",
      multipleFilters: "{count} filters",
      jobCompleteEmail: "Job Complete Email",
      jobCompleteEmailDesc: "Sends an email notification to selected recipients when the bulk task job has completed",
      jobErrorEmail: "Job Error Email", 
      jobErrorEmailDesc: "Sends an email notification to selected recipients when the bulk task job has encountered an error",
      jobResultsEmail: "Job Results Email",
      jobResultsEmailDesc: "Sends an email containing the job results or output contents to selected recipients"
    }
  }
};